
import './Search.css';

import { useState, useEffect, useRef } from 'react';
import { Route, Link } from 'react-router-dom';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Cookie from 'js-cookie';

import useFetch from '../../CustomeHooks/useFetch';
import Footer from '../Footer/Footer';
import JobsList from '../../aImages/jobslist_2.jpg';
import JobItem from '../JobItem/JobItem';
import ServerCall from '../ServerCall/ServerCall';
import { isValidToken } from '../../Javascript_Functions_to_export/Utils';
import { 
        getCountries,
        getEmploymentTypes, 
        getWorkPlaces, 
        getGenders, 
        getJobCategories  } from '../../Javascript_Functions_to_export/Utils';
import { useToast } from '../../CustomeHooks/useToast';
import AutoCompleteInput from '../AutoCompleteInput/AutoCompleteInput';

import socket from '../../SocketConnection/Socket';

import { getUserFromCookie } from '../../Javascript_Functions_to_export/Utils';

const Search = () => {

    const toast = useToast();

    const location = useLocation();

    //_________________________Search criteria block_____________________________
    
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [recentlyJobs, setRecentlyJobs] = useState("Here are the Recently Jobs (24 hours ago)");

    // Drop Downs list Values
    const [countries, setCountries] = useState();
    const [categories, setCategories] = useState();
    const [employmentTypes, setEmploymentTypes] = useState();
    const [workPlaces, setWorkPlaces] = useState();
    const [genders, setGenders] = useState();

    // Search criteria
    const [country, setCountry] = useState(0);
    const [category, setCategory] = useState(0);    // IT|Sales|Teaching|Other.
    const [employmentType, setEmploymentType] = useState(10); 
    const [workplace, setWorkplace] = useState(10);
    const [gender, setGender] = useState(10);
    const [postedDate, setPostedDate] = useState(0);

    const userClicksSearch = useRef(false);

    //const jobsInNDays = useRef(null); // old code
    const jobsInNDays = useRef([]);

    //console.log("jobsInNDays.current = ", jobsInNDays.current);

    // The purpose of adding this line is to send the cookies automatically with each request. check the link below
    // https://stackoverflow.com/questions/43002444/make-axios-send-cookies-in-its-requests-automatically
    axios.defaults.withCredentials = true;

    useEffect(() => {
        
        //console.log("start in useEffect[searchParams]");
        //debugger;

        var countriesWithoutGrouping = getCountries();
        var categoriesWithoutGrouping = getJobCategories();
        setEmploymentTypes(getEmploymentTypes()); 
        setWorkPlaces(getWorkPlaces());
        setGenders(getGenders());

        
        // This block of code was in the useEffect({ },[]) start
        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        if(localStorage.getItem('CurrentPage')) {
            getCorrentItems(parseInt(localStorage.getItem('CurrentPage')));
        }

        // This block of code was in the useEffect({ },[]) end

        var country = 0, cat = 0, empType = 10, workplace = 10, gender = 10, postedDate = 0;
        if(searchParams.size != 0) {

            // ________________________________
            // The Idea here is simply: if there is/are params, set all ddl values (and grouped them),
            // then fetch the data based on these params.
            // if everything is ok, GOOD, if not, return failed (with the correct message).

            //console.log("searchParams.size != 0");

            // If There is/are params in the entered URL, and a required one is missing:
            // If user enters "/search?country=125"
            
            

            axios.defaults.withCredentials = true;
            axios.get(process.env.REACT_APP_URL + '/getJobsInLastNDays/' + numberOfDays)  // 7 means: in last 7 days.
            .then((res) => {
                if(res.data && res.data.status.toLowerCase() === 'success') {
                    jobsInNDays.current = res.data.jobsDetails;
                    //console.log(res.data);
                    if(Array.isArray(jobsInNDays.current) && categoriesWithoutGrouping) {
                        
                        //console.log(categories);
                        setCategories(groupJobsByCategory(
                            categoriesWithoutGrouping, 
                            jobsInNDays.current, 
                            parseInt(searchParams.get('country')) > 0 ?  // was > 10: => bug
                            parseInt(searchParams.get('country')) 
                            : 
                            0
                        ));
                    }
                    
                    if(Array.isArray(jobsInNDays.current) && countriesWithoutGrouping) {
                        setCountries(groupJobsByCountry(
                            countriesWithoutGrouping, 
                            jobsInNDays.current, 
                            parseInt(searchParams.get('category')) > 0 ? // was > 10: => bug
                            parseInt(searchParams.get('category'))
                            : 
                            0
                        ));
                    }
                }
                else {
                    toast("error", res.data.message)
                }
            })
            .catch((error) => { 
                console.log(error);
            })
            .finally(() => { });
        

            // Set every search param to its value ANYWAY.
            if(searchParams.get('country')) {
                country = searchParams.get('country');
                //console.log("inside setting country");
                setCountry(searchParams.get('country'));
            }

            if(searchParams.get('category')) {
                cat = searchParams.get('category');
                setCategory(searchParams.get('category'));
            }

            if(searchParams.get('employmentType')) {
                empType = searchParams.get('employmentType');
                setEmploymentType(searchParams.get('employmentType'));
            }

            if(searchParams.get('workplace')) {
                workplace = searchParams.get('workplace');
                setWorkplace(searchParams.get('workplace'));
            }

            if(searchParams.get('gender')) {
                gender = searchParams.get('gender');
                setGender(searchParams.get('gender'));
            }

            if(searchParams.get('postedDate')) {
                postedDate = searchParams.get('postedDate')
                setPostedDate(searchParams.get('postedDate'));
            }
        
            // If required params is/are missing, go to Server and return failed.
            //if(!fetchJobsFromDB) {
                // Solved it by returning isLoading = false from useFetch hook.
                //isLoading = false;
                //return;
            //}

            // Every time the search page is opened, if there is no search criteria at all, 
            // Get only the "Recently Jobs (aka postedDate = 1)"
            // if(!localStorage.getItem('search')) {
            //     console.log("reset search criteria");
            //     setUrl(process.env.REACT_APP_URL + '/students/0/0/0/0/0/1');
            // }

            var Url = process.env.REACT_APP_URL + '/students/' + 
                    country + "/" + 
                    cat + "/" + 
                    empType + "/" + 
                    workplace + "/" + 
                    gender + "/" + 
                    postedDate;

            // if there are search params, then set url again to fetch data based on these search params.
            setUrl(Url);

            var linkToNavigate = "?";
            if(country > 0)
                linkToNavigate += "country=" + country + "&";
            if(cat > 0)
                linkToNavigate += "category=" + cat + "&";
            if(empType > 10)
                linkToNavigate += "employmentType=" + empType + "&";
            if(workplace > 10)
                linkToNavigate += "workplace=" + workplace + "&";
            if(gender > 10)
                linkToNavigate += "gender=" + gender + "&";
            //if(postedDate > 10)  // code that did the bug
            if(postedDate > 0)
                linkToNavigate += "postedDate=" + postedDate + "&";

            // if linkToNavigate ends with "&", remove it.
            if(linkToNavigate[linkToNavigate.length - 1] === "&")
                linkToNavigate = linkToNavigate.slice(0, linkToNavigate.length - 1);
            localStorage.setItem('search', linkToNavigate);

            // remove "Recently jobs" in case there is any param, || user fetched data 45 days ago
            if(recentlyJobs) {
                //debugger;
                setRecentlyJobs(null);
            }
            
        }
        else {
            if(searchParams.size === 0) {

                //console.log("searchParams.size == 0");

                setUrl(process.env.REACT_APP_URL + '/students/0/0/10/10/10/1');
                setRecentlyJobs("Here are the Recently Jobs (24 hours ago)");

                setCountry(0);
                setCategory(0);
                setEmploymentType(10); 
                setWorkplace(10);
                setGender(10);
                setPostedDate(0);


                // Load all Jobs from DB 7 days ago
                // (I did not use the existing useFetch hook, to prevent the call every time the url changes),

                //var countriesWithoutGrouping = getCountries(); 
                //var categoriesWithoutGrouping = getJobCategories();

                axios.defaults.withCredentials = true;
                axios.get(process.env.REACT_APP_URL + '/getJobsInLastNDays/' + numberOfDays)  // 7 means: in last 7 days.
                .then((res) => {
                    if(res.data && res.data.status.toLowerCase() === 'success') {
                        //debugger;
                        jobsInNDays.current = res.data.jobsDetails;
                        //console.log("paramsize == 0");
                        //debugger;
                        //console.log(groupJobsByCountry(countriesWithoutGrouping, res.data.jobsDetails, 0));
                        setCountries(groupJobsByCountry(countriesWithoutGrouping, res.data.jobsDetails, 0));
                        setCategories(groupJobsByCategory(categoriesWithoutGrouping, res.data.jobsDetails, 0));
                    }
                    else {
                        toast("error", res.data.message)
                    }
                })
                .catch((error) => { 
                    console.log(error);
                })
                .finally(() => { });

            }
        }
        setData(null);

        // [] start
        //window.scrollToX(0, 0);
        //userClicksSearch.current = false;
        // [] end

    }, [searchParams]);
    
    

    

    useEffect(() => {
    
        //console.log("once");
        //window.scrollToX(0, 0);
        userClicksSearch.current = false;

        socket.emit("pageVisit", 
            { 
                page: "Search", 
                isLoggedIn: Cookie.get('token') ? true : false,
                username: Cookie.get('token') ? getUserFromCookie(Cookie.get('token')).Username : null,
            });

        return;

        if(!countries || countries.length === 0)
            setCountries(getCountries());

        //if(!categories || categories.length === 0)
            //setCategoriesX(getJobCategories());
        
        setEmploymentTypes(getEmploymentTypes()); 
        setWorkPlaces(getWorkPlaces());
        setGenders(getGenders());

        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        if(localStorage.getItem('CurrentPage')) {
            //getCorrentItemsX(parseInt(localStorage.getItem('CurrentPage')));
        }

        // Every time the search page is opened, check if there is no search criteria at all, 
        // Get only the "Recently Jobs (aka postedDate = 1)"
        if(!localStorage.getItem('search')) {
            //console.log("reset search criteria");
            setUrl(process.env.REACT_APP_URL + '/students/0/0/0/0/0/1');
        }

        window.scrollToX(0, 0);
        userClicksSearch.current = false;

    }, []);

    const groupJobsByCategory = (CategoriesWithoutGrouping, 
                            jobsInNDays,
                            CountryId
                        ) => {
        var jobs, selCountryName = null;
    
        for (let j = 1; j < CategoriesWithoutGrouping.length; j++) {
            if(parseInt(CountryId) > 0) {
                jobs = jobsInNDays.filter(job => parseInt(job.JobCategory) === parseInt(CategoriesWithoutGrouping[j].Id)
                                                    && parseInt(job.Country) === parseInt(CountryId));
            }
            else {
                
                jobs = jobsInNDays.filter(job => parseInt(job.JobCategory) === parseInt(CategoriesWithoutGrouping[j].Id));
            }

            if(jobs) {
                //console.log("jobs = ", jobs);

                if(jobs.length === 0) { 
                    CategoriesWithoutGrouping[j].details = "No jobs in last week";
                }
                else if(jobs.length === 1) {
                    CategoriesWithoutGrouping[j].details = "✅ 1 job in last week";
                }
                else {
                    CategoriesWithoutGrouping[j].details = "✅ " + jobs.length + " jobs in last week";
                }

                //if(selCountryName)
                    //CategoriesWithoutGrouping[j].details += "_(" + selCountryName + ")";
            }
            else {
                console.log("jobs = ", typeof(jobs));
            }
        }
        return CategoriesWithoutGrouping;
    }

    const groupJobsByCountry = (CountriesWithoutGrouping, 
                            jobsInNDays,
                            CategoryId
                        ) => {
                            //debugger;
        var jobs, selCatName = null;
        // if(parseInt(CategoryId) > 0) {
        //     var selCat = getJobCategories().filter(cat => parseInt(cat.Id) === parseInt(CategoryId))[0];
        //     if(selCat)
        //         selCatName = selCat.Name;
        // }

        for (let j = 1; j < CountriesWithoutGrouping.length; j++) {
            if(parseInt(CategoryId) > 0) {
                jobs = jobsInNDays.filter(job => parseInt(job.Country) === parseInt(CountriesWithoutGrouping[j].Id)
                                                    && parseInt(job.JobCategory) === parseInt(CategoryId));
            }
            else {
                jobs = jobsInNDays.filter(job => parseInt(job.Country) === parseInt(CountriesWithoutGrouping[j].Id));
            }

            if(jobs) {
                if(jobs.length === 0) { 
                    CountriesWithoutGrouping[j].details = "No jobs in last week ";
                }
                else if(jobs.length === 1) {
                    CountriesWithoutGrouping[j].details = "✅ 1 job in last week ";
                }
                else {
                    CountriesWithoutGrouping[j].details = "✅ " + jobs.length + " jobs in last week ";
                }

                //if(selCatName)
                    //CountriesWithoutGrouping[j].details += "_(" + selCatName + ")";
                //console.log(CountriesWithoutGrouping[j].details);
            }
        }
        return CountriesWithoutGrouping;
    }


    //____________________Once the user opens the "Search" page, display all recently jobs_____________ 
    const [data, setData] = useState(null);

    const [url, setUrl] = useState();
    //debugger;
    //const { lsData, isLoading, itemsNb } = useFetch(url);
    const { lsData, isLoading, itemsNb, lsPinnedJobs } = useFetch(url);
        
    //console.log("lsPinnedJobs = ", lsPinnedJobs);

    useEffect(() => {

        if(lsData && lsData.length > 0) {

            setLinksNb(Array.from({ 
                length: Math.ceil(lsData.length / jobsPerPage)
                //length: Math.ceil(90 / jobsPerPage)
            }, (_, i) => i + 1));   //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

            // *********** new code **********
            var activeLink = 1;
            var _linksNb = Array.from({ 
                length: Math.ceil(lsData.length / jobsPerPage)
            }, (_, i) => i + 1);

            //The bug was : Set "CurrentPage" = 3, then fetch the recently jobs => nothing appears
            if(parseInt(localStorage.getItem('CurrentPage')) > _linksNb.length)
                localStorage.setItem('CurrentPage', 1);

            if(localStorage.getItem('CurrentPage'))
                activeLink = parseInt(localStorage.getItem('CurrentPage'));

            if(activeLink !== _linksNb.length + 1) {
                //console.log("lsData = ", lsData);
                setData([...lsData.slice((activeLink - 1) * jobsPerPage, activeLink * jobsPerPage)]);
            }
            else
                setData([...lsData.slice((activeLink - 1) * jobsPerPage)]); 
        }
        else {
            setData([]);
        }

        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
        // https://stackoverflow.com/questions/5007530/how-do-i-scroll-to-an-element-using-javascript

        
        let width = window.innerWidth;
        // if user uses mobile
        if(width <= 500 && (userClicksSearch.current === true || (lsData && lsData.length > 0))) {   // old
        //if(width <= 500 && (lsData && lsData.length > 0)) { // 31/Mar/2025
            //console.log("will scroll auto");
            setTimeout(() => {
                window.scrollTo({
                    top: 900,
                    behavior: "smooth"
                });
            }, 500);
        }
    }, [lsData]);


    // This function will not be called unless the user sets the "Country".
    // function getJobsInNDaysFromDB () {
    //     console.log("getJobsInNDaysFromDB()");

    //     axios.defaults.withCredentials = true;
    
    //     axios.get(process.env.REACT_APP_URL + '/getJobsInLastNDaysX/' + numberOfDays)  // 7 means: in last 7 days.
    //     .then((res) => {
    //         if(res.data && res.data.status.toLowerCase() === 'success') {
    //             // worked correctly and wait 3s
    //             //await new Promise(resolve => setTimeout(resolve, 3000));
    //             return Promise.resolve(res.data.jobsDetails);
    //         }
    //         else {
    //             return Promise.error(res.data.message);
    //         }
    //     })
    //     .catch((error) => { 
    //         return Promise.error("error");
    //     })
    //     .finally(() => { });

    //     //console.log("getJobsInNDaysFromDB()"); 
    // }

    const _setCountry = (_id) => {
        setCountry(_id);
        
        //if(jobsInNDays.current) // old code
        
        if(Array.isArray(jobsInNDays.current)) {
            setCategories(groupJobsByCategory(categories, jobsInNDays.current, _id));
            //console.log("Jobs grouped by Categories");
        }
        
        else {
            console.log("jobsInNDays.current is null");
            // Add an EndPoint to insert an error message in DB, (error = jobsInNDays.current was null or Undefined) 

        //     axios.defaults.withCredentials = true;
        //     axios.get(process.env.REACT_APP_URL + '/getJobsInLastNDaysX/' + numberOfDays)  // 7 means: in last 7 days.
        //     .then((res) => {
        //         if(res.data && res.data.status.toLowerCase() === 'success') {
        //             jobsInNDays.current = res.data.jobsDetails;
        //             setCategoriesX(groupJobsByCategory(categories, jobsInNDays.current, _id));
        //         }
        //         else {
        //             toast("error", res.data.message);
        //         }
        //     })
        //     .catch((error) => { 
        //         console.log(error);
        //     })
        //     .finally(() => { });
        }
    }
    
    const numberOfDays = 7;

    const _setCategory = (_id) => {
        
        setCategory(_id);
        
        // Update jobs grouping in the "Country" control

        //if(jobsInNDays.current)  // old code, give the bug (it wasn't executing the if, nor the else)
        
        if(Array.isArray(jobsInNDays.current)) {
            setCountries(groupJobsByCountry(countries, jobsInNDays.current, _id));
            //console.log("Jobs grouped by Countries");
        }

        else {
            console.log("jobsInNDays.current is null");
            // Add an EndPoint to insert an error message in DB, (error = jobsInNDays.current was null or Undefined) 
            
        //     axios.defaults.withCredentials = true;
        //     axios.get(process.env.REACT_APP_URL + '/getJobsInLastNDaysX/' + numberOfDays)  // 7 means: in last 7 days.
        //     .then((res) => {
        //         if(res.data && res.data.status.toLowerCase() === 'success') {
        //             jobsInNDays.current = res.data.jobsDetails;
        //             setCountries(groupJobsByCountry(countries, jobsInNDays.current, _id));
        //         }
        //         else {
        //             toast("error", res.data.message)
        //         }
        //     })
        //     .catch((error) => { 
        //         console.log(error);
        //     })
        //     .finally(() => { });
        }
    }

    const _setEmploymentType = (_id) => {
        setEmploymentType(_id);
    }
    
    const _setWorkplace = (_id) => {
        setWorkplace(_id);
    }

    const _setGender = (_id) => {
        setGender(_id);
    }

    const _setPostedDate = (_id) => {
        setPostedDate(_id);
    }

    const getCorrentItems = (linkNumber) => {
        
        //console.log("in getCorrentItems");

        //if(lsData) {  // old line
        if(lsData && Array.isArray(lsData)) {  // new line

            if(linkNumber !== linksNb.length + 1)
                setData([...lsData.slice((linkNumber - 1) * jobsPerPage, linkNumber * jobsPerPage)]);
            else
                setData([...lsData.slice((linkNumber - 1) * jobsPerPage)]); 
        
            setActiveLink(linkNumber);
            localStorage.setItem('CurrentPage', linkNumber);

            let width = window.innerWidth;
            // if user uses mobile
            //if(width <= 500) {
            // if(width <= 500 && (userClicksSearch.current === true || (lsData && lsData.length > 0))) {
            //     console.log("will scroll auto");
            //     setTimeout(() => {
            //         window.scrollTo({
            //             //top: 1000, //old
            //             top: 900,
            //             behavior: "smooth"
            //         });
            //     }, 100);
            // }
        }
    }



    // _____________  Pagination Block START ______________________________
    const [activeLink, setActiveLink] = useState(1);
    const [jobsPerPage, setJobsPerPage] = useState(10);
    const [linksNb, setLinksNb] = useState([]);

    // _____________  Pagination Block END ________________________________

    //console.log("lsData", lsData);

    // When user clicks "Search Jobs" button
    const handleSubmit = (e) => {

        //console.log("user clicked Search button");

        e.preventDefault();

        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        if(parseInt(country) < 1) {
            toast('warning', 'Please select a "Country" !');
            return;
        }

        if(parseInt(category) < 10) {
            toast('warning', 'Please select a "Category" !');
            return;
        }

        var newUrl = process.env.REACT_APP_URL + '/students/' + 
                    country + '/' +
                    category + '/' +
                    employmentType + '/' + 
                    workplace + '/' +
                    gender + '/' +
                    postedDate;
        //console.log(newUrl);
        //return;
        if(url === newUrl) {
            toast('warning', 'You are searching with the same criteria !');
            return;
        }

        localStorage.setItem('CurrentPage', 1);
        setActiveLink(1);
        setData(null);

        setUrl(newUrl);

        if(recentlyJobs) {
            //debugger;
            setRecentlyJobs(null);
        }

        var linkToNavigate = "/search?";
        if(country > 0) 
            linkToNavigate += "country=" + country + "&";
        if(category > 0) 
            linkToNavigate += "category=" + category + "&";
        if(employmentType > 10)
            linkToNavigate += "employmentType=" + employmentType + "&";
        if(workplace > 10)
            linkToNavigate += "workplace=" + workplace + "&";
        if(gender > 10)
            linkToNavigate += "gender=" + gender + "&";
        //if(postedDate > 10)  // code that did the bug
        if(postedDate > 0)
            linkToNavigate += "postedDate=" + postedDate + "&";

        // Store the "Search Criteria"
        var indexOfQuestionMark = linkToNavigate.lastIndexOf('?');
        var searchQuery = linkToNavigate.slice(indexOfQuestionMark);
        if(searchQuery[searchQuery.length - 1] === "&")
            searchQuery = searchQuery.slice(0, searchQuery.length - 1);
        if(searchQuery === "?")
            localStorage.setItem('search', '?country=0&category=0&employmentType=10&workplace=10&gender=10&postedDate=0');
        else
            localStorage.setItem('search', searchQuery);

        // if linkToNavigate still = "/search?", remove the "?"
        if(linkToNavigate === "/search?")
            linkToNavigate = "/search?country=0&category=0&employmentType=10&workplace=10&gender=10&postedDate=0";

        // if linkToNavigate ends with "&", remove it.
        if(linkToNavigate[linkToNavigate.length - 1] === "&")
            linkToNavigate = linkToNavigate.slice(0, linkToNavigate.length - 1);

        userClicksSearch.current = true;
        navigate(linkToNavigate);

        //console.log("will scroll auto");
        
        // setTimeout(() => {
        //     window.scrollToX({
        //         top: 300,
        //         behavior: "smooth"
        //     });
        // }, 300);
    }

    const dateRanges = 
        [
            { Id: 0, Name: 'All' },
            { Id: 1, Name: 'Yesterday' },
            { Id: 3, Name: 'Last 3 days' },
            { Id: 7, Name: 'Last week' },
            { Id: 14, Name: 'Last 2 weeks' },
            { Id: 30, Name: 'Last month' },
        ]

    return(
    <div className='search-container every-page-container'>

        
        {/* <div>
            <img src={ JobsList } className="top-img" alt='jobs list' />
        
            <div className='blue-div'>
                Jobs List
            </div>
            <div className='home-jobslist'>
                Home &gt; Jobs List
            </div>
        </div> */}




{/* ___________________________ "Recently Jobs" Desktop message _________________________________________ */}
        {/* <div className="recently-jobs" style={{ 
                marginRight: '27%',
                marginLeft: 'auto',
                color: 'rgb(193 193 193)',
                position: 'relative',
                width: 'max-content',
                fontStyle: 'italic',
                height: '27px',
                marginBottom: '-24px',
                marginTop: '22px',
                visibility: recentlyJobs ? 'visible' : 'hidden' 
            }}>
            { !isLoading && recentlyJobs }
        </div>  */}
{/* ___________________________ "Recently Jobs" Desktop message _________________________________________ */}

        {/* <div id='ImageAd' style={{ textAlign: "center", marginTop: "20px" }}>
            <img src='Ad2.png' alt='Ad'
                style={{ width: "50%", height: "200px", border: "solid 1px red",  }}/>
        </div> */}

        {/* <div style={{ border: "solid 1px red", width: "100%", height: "60px", marginTop: "40px" }}></div> */}

        <div className="real-page-content">

            {/* Ads Section - Start */}
            {/* <div style={{ border: "solid 1px red", height: "100px", position: "fixed", marginLeft: "-90px",}}>
                <img src='Ad2.png' alt='Ad'/>
            </div> */}
            {/* Ads Section - End */}


            <div className='search-fields-area' id="resultData">
                <form onSubmit={ (e) => handleSubmit(e) }>

                    <input name='search_jobs_list'
                        type='submit' 
                         className={`search-btn ${isLoading === true ? 'disabled' : ''}`}
                         value={`${isLoading === true ? 'Searching...' :
                            'Search' }`} 
                         disabled={ isLoading === true } />

                {/* <input type="submit"
                       className="search-btn"
                       value={ isLoading === true ? 'Searching ...' : 'Search Jobs' } 
                       style={{ visibility: isLoading === true ? 'hidden' : 'visible' }}/> */}

                {/*<input name='search_jobs_list'
                        type='submit' 
                         className={`search-btn ${isLoading === true ? 'disabled' : ''}`}
                         value={`${isLoading === true ? 'Searching...' :
                            lsData.length === 0 ? 'Search' :
                            `Search (${ lsData.length } result(s) found)` }`} 
                         disabled={ isLoading === true } />*/}

                    

                    <div>    
                        <div className='search-field-title'>Country<span style={{ color: 'red' }}>&nbsp;*</span>
                        {
                            country > 0 && 
                            <i className="fa fa-trash-o clear-value" 
                                aria-hidden="true" 
                                onClick={ () => _setCountry(0) }></i>
                        }
                        </div>
                        <div>
                            { 
                                countries && 
                                categories &&
                                Array.isArray(countries) &&
                                //categories.length > 1 &&
                                countries.length > 0 ?
                                <AutoCompleteInput 
                                    // placeholder="Type to search ..." 
                                    placeholder= {`Search ${ 
                                        (parseInt(category) > 0 &&
                                        categories.filter(c => parseInt(c.Id) === parseInt(category)) &&
                                        categories.filter(c => parseInt(c.Id) === parseInt(category))[0]) ? 
                                        'in "' + (categories.filter(c => parseInt(c.Id) === parseInt(category))[0].Name.length <= 24 ? 
                                        categories.filter(c => parseInt(c.Id) === parseInt(category))[0].Name + '"': 
                                        categories.filter(c => parseInt(c.Id) === parseInt(category))[0].Name.substring(0, 24) + '..."')
                                        : 
                                        '' } `}
                                    pAllCountries={ countries }
                                    selCountryId = { country }  //'country' means CountryId
                                    fnOnChange={ _setCountry } 
                                    index="1"
                                    matchedEltHeight = "50"
                                    matchingListHeight = "187"
                                    showSearchLine = { true }
                                    showFirstItem = { false }
                                />
                                :
                                // To prevent lazy loading
                                <AutoCompleteInput 
                                    // placeholder="Type to search ..." 
                                    placeholder= "Loading Countries ..."
                                    pAllCountries={ [{ Id: 0, Name: "Loading Countries ..." }] }
                                    selCountryId = "0"   //'country' means CountryId
                                    fnOnChange={ _setCountry } 
                                    index="1"
                                    matchedEltHeight = "50"
                                    matchingListHeight = "187"
                                    showSearchLine = { false }
                                    showFirstItem = { false }
                                />
                            }
                        </div>
                    </div>

                    {/* <div>    
                        <div className='search-field-title'>Country {country} <span style={{ color: 'red' }}>*</span></div>
                        <div>
                                <select onChange={ (e) => setCountryX(e.target.value) } value={ country }>
                                {
                                    countries && 
                                    Array.isArray(countries) &&
                                    countries.map((country, index) => {
                                        return(
                                            <option key={index} 
                                                    value={ country.Id }>
                                                    { country.Name }
                                            </option>                                        
                                        )
                                    })
                                }
                            </select>
                        </div>
                    </div> */}


                    <div>    
                        <div className='search-field-title'>Category<span style={{ color: 'red' }}>&nbsp;*</span>
                            {
                                category > 0 && 
                                <i className="fa fa-trash-o clear-value" 
                                    aria-hidden="true" 
                                    onClick={ () => _setCategory(0) }></i>

                                // <div className="clear-value"
                                //     onClick={ () => _setCategory(0) }><u>X</u></div> 
                                // clear || reset || delete || remove || cancel || erase || x
                            }
                        </div>
                        <div>

                            { 
                                categories && 
                                countries &&
                                Array.isArray(categories) &&
                                categories.length > 0 ?
                                <AutoCompleteInput 
                                    placeholder= {`Search ${ 
                                        (parseInt(country) > 0 &&
                                        countries.filter(c => parseInt(c.Id) === parseInt(country)) &&
                                        countries.filter(c => parseInt(c.Id) === parseInt(country))[0] &&
                                        countries.filter(c => parseInt(c.Id) === parseInt(country))[0].Name) ? 
                                        'in "' + (countries.filter(c => parseInt(c.Id) === parseInt(country))[0].Name.length <= 24 ? 
                                        countries.filter(c => parseInt(c.Id) === parseInt(country))[0].Name + '"': 
                                        countries.filter(c => parseInt(c.Id) === parseInt(country))[0].Name.substring(0, 24) + '..."')
                                        : 
                                        '' } `}
                                    // placeholder= "Search in "
                                    pAllCountries={ categories }
                                    selCountryId = { category }  //'category' means CategoryId
                                    fnOnChange={ _setCategory }
                                    index="2"
                                    matchedEltHeight = "50"
                                    matchingListHeight = "187"
                                    showSearchLine = { true }
                                    showFirstItem = { false }
                                />
                                :
                                <AutoCompleteInput 
                                    placeholder= "Loading Categories ..."
                                    // placeholder= "Search in "
                                    pAllCountries={ [{ Id: 0, Name: "Loading Categories ..." }] }
                                    selCountryId = "0"  //'category' means CategoryId
                                    fnOnChange={ _setCategory }
                                    index="2"
                                    matchedEltHeight = "50"
                                    matchingListHeight = "187"
                                    showSearchLine = { true }
                                    showFirstItem = { false }
                                />
                            }
                        </div>
                    </div>

                    {/* <div>    
                        <div className='search-field-title'>Category <span style={{ color: 'red' }}>*</span></div>
                        <div>
                            <select onChange={ (e) => setCategory(e.target.value) } value={ category }>
                            {
                                categories && 
                                Array.isArray(categories) &&
                                categories.map((category, index) => {
                                    return(
                                        <option key={index} 
                                                value={ category.Id }>
                                                    { category.Name }
                                        </option>                                        
                                    )
                                })
                            }
                            </select>
                        </div>
                    </div> */}

                    <div>    
                        <div className='search-field-title'>Employment Type</div>
                        <div>

                            { 
                                employmentTypes && 
                                Array.isArray(employmentTypes) &&
                                employmentTypes.length > 0 &&
                                <AutoCompleteInput 
                                    placeholder="Type to search ..." 
                                    pAllCountries={ employmentTypes }
                                    selCountryId = { employmentType }
                                    fnOnChange={ _setEmploymentType } 
                                    index="3"
                                    matchingListHeight = "187"
                                    showSearchLine = { true }
                                    showFirstItem = { true } />
                            }
                        </div>
                    </div>
                    {/* <div>
                        <div className='search-field-title'>Employment Type</div>
                        <div>                  
                            <select onChange={ (e) => setEmploymentType(e.target.value) } value={ employmentType }>
                            {
                                    employmentTypes && 
                                    Array.isArray(employmentTypes) &&
                                    employmentTypes.map((type, index) => {
                                        return(
                                            <option key={index} 
                                                    value={ type.Id }>
                                                        { type.Name }
                                            </option>                                        
                                        )
                                    })
                            }
                            </select>
                        </div>          
                    </div> */}

                    <div>    
                        <div className='search-field-title'>Workplace</div>
                        <div>
                            { 
                                workPlaces && 
                                Array.isArray(workPlaces) &&
                                workPlaces.length > 0 &&
                                <AutoCompleteInput 
                                    placeholder="Type to search ..." 
                                    pAllCountries={ workPlaces }
                                    selCountryId = { workplace }
                                    fnOnChange={ _setWorkplace } 
                                    index="4"
                                    showSearchLine = { false }
                                    showFirstItem = { true } />
                            }
                        </div>
                    </div>
                    {/* <div>
                        <div className='search-field-title'>Workplace</div>
                        <div>                  
                            <select onChange={ (e) => setWorkplace(e.target.value) } value={ workplace }>
                            {
                                    workPlaces && 
                                    Array.isArray(workPlaces) &&
                                    workPlaces.map((work, index) => {
                                        return(
                                            <option key={index} 
                                                    value={ work.Id }>
                                                        { work.Name }
                                            </option>                                        
                                        )
                                    })
                            }
                            </select>
                        </div>          
                    </div> */}

                    <div>    
                        <div className='search-field-title'>Gender</div>
                        <div>

                            { 
                                genders && 
                                Array.isArray(genders) &&
                                genders.length > 0 &&
                                <AutoCompleteInput 
                                    placeholder="Type to search ..." 
                                    pAllCountries={ genders }
                                    selCountryId = { gender }
                                    fnOnChange={ _setGender } 
                                    index="5"
                                    matchingListHeight = "114"
                                    showSearchLine = { false }
                                    showFirstItem = { true } />
                            }
                        </div>
                    </div>
                    {/* <div>
                        <div className='search-field-title'>Gender</div>
                        <div>                  
                            <select onChange={ (e) => setGender(e.target.value) } value={ gender }>
                            {
                                    genders && 
                                    Array.isArray(genders) &&
                                    genders.map((gender, index) => {
                                        return(
                                            <option key={index} 
                                                    value={ gender.Id }>
                                                        { gender.Name }
                                            </option>                                        
                                        )
                                    })
                            }
                            </select>
                        </div>          
                    </div> */}


                    <div>    
                        <div className='search-field-title'>Date Posted</div>
                        <div>

                            {   
                                // dateRanges && 
                                // Array.isArray(dateRanges) &&
                                // dateRanges.length > 0 && 
                                <AutoCompleteInput 
                                    placeholder="Type to search ..." 
                                    pAllCountries= { [
                                        { Id: 0, Name: 'All' },
                                        { Id: 1, Name: 'Yesterday' },
                                        { Id: 3, Name: 'Last 3 days' },
                                        { Id: 7, Name: 'Last week' },
                                        { Id: 14, Name: 'Last 2 weeks' },
                                        //{ Id: 30, Name: 'Last month' },
                                    ] }
                                    selCountryId = { postedDate }
                                    fnOnChange={ _setPostedDate } 
                                    index="6"
                                    matchingListHeight = "188"
                                    showSearchLine = { false }
                                    showFirstItem = { true } />
                            }
                        </div>
                    </div>

                    {/* <div>
                        <div className='search-field-title'>Date Posted</div>
                        <div>                 
                            <select onChange={ (e) => setPostedDate(e.target.value) } value={ postedDate }>
                                <option value='0'>All</option>
                                <option value='1'>Yesterday</option>
                                <option value='3'>Last 3 days</option>
                                <option value='7'>Last week</option>
                                <option value='14'>Last 2 weeks</option>
                                <option value='30'>Last month</option>
                            </select>
                        </div>          
                    </div> */}

                    {/* <input type='submit' value='Search' /> */}

                    {/* <Link to='/makeservercall' state={ searchCriteria }>
                        <i className="fa fa-search" aria-hidden="true" style={{ fontSize : "30px"}}></i>
                    </Link> */}

                    

                </form>
            </div>
                        
            {/* <ServerCall /> */}
            <div className='bottom-part' style={{ width: '100%'}}>
            {
                isLoading === true && 
                <div style={{ marginRight: 'auto', 
                                marginLeft: 'auto', 
                                position: 'relative', 
                                top: '50%', 
                                width: '69%',
                                fontSize: '20px',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                color: '#ff6464' }}>
                        Loading ...
                </div>
            } 
                

            {/* <div>Pinned Jobs</div> background = #f7fff7*/}
            {/* Pinned Jobs list Start */}
            {
                isLoading === false &&
                lsPinnedJobs &&
                Array.isArray(lsPinnedJobs) &&
                lsPinnedJobs.length > 0 &&
                // new search layout : remove style in the div below
                <div className='jobs-list' id="pinned-jobs-list" style={{ marginBottom: "100px" }}>
                    {/* PinnedJobs list should appear here */}
                    {
                        
                        lsPinnedJobs.map((job, key) => {
                            return(
                                <div key={ key } style={{ width: '100%', background: '#f7fff7' }}>
                                    <JobItem _jobItem={ job } />
                                </div>
                            )
                        })
                        
                    }
                </div>
            }
            {/* Pinned Jobs list End */}
            

            {/* .Gif ads START*/}
            {/* <div className='ads-135px'>
                <img src='Adgif.gif' alt='Ad1' className='ad-item-135'/>
                <img src='Adgif.gif' alt='Ad2' className='ad-item-135'/>
            </div> */}
            {/* .Gif ads END*/}


            { 
                isLoading === false &&
                recentlyJobs &&
                <div className="recently-jobs" style={{ 
                            marginRight: '27%',
                            marginLeft: 'auto',
                            color: 'rgb(193 193 193)',
                            position: 'relative',
                            width: 'max-content',
                            fontStyle: 'italic',
                            height: '50px',
                            //visibility: recentlyJobs ? 'visible' : 'hidden' 
                            display: recentlyJobs ? 'block' : 'none',
                            //display: 'block' 
                        }}>
                        { !isLoading && recentlyJobs }
                </div>
            }
                
            { 
                isLoading === false &&
                data && 
                Array.isArray(data) &&
                data.length > 0 && 
                <>
                    {/* _______ "Recently Jobs" mobile message _____ */}
                    <div className="mobile-recently-jobs" style={{ 
                            // marginRight: '27%',
                            // marginLeft: 'auto',
                            marginBottom: '20px',
                            marginTop: '-40px',
                            paddingLeft: '10px',
                            color: 'rgb(193 193 193)',
                            position: 'relative',
                            width: 'fit-content',
                            // border: 'solid 1px #e0e0e0',
                            // padding: '5px',
                            fontStyle: 'italic',
                            fontSize: '14px',
                            // height: '27px',
                            textAlign: 'center',
                            // visibility: recentlyJobs ? 'visible' : 'hidden',
                            display: recentlyJobs ? 'block' : 'none' ,
                        }}>
                            
                        { !isLoading && recentlyJobs }
                    </div> 
                    {/* _______ "Recently Jobs" mobile message ________ */}
                



                    <div className='jobs-list' id='jobsList'>
                        
                        {
                            data &&
                            Array.isArray(data) &&
                            data.map((job, key) => {
                                return(

                                    <div key={ key } style={{ width: '100%' }}>
                                        <JobItem _jobItem={ job } />
                                    </div>
                                )
                            })
                        }


                        <div className='pagination-block'>
                            {
                                linksNb &&
                                Array.isArray(linksNb) &&
                                linksNb.length > 1 &&    // there is more than 1 link
                                linksNb.map((link, index) => {
                                    return(
                                        <div key={index}
                                            className={ activeLink === link ? 'active-link one-link' : 'one-link' }
                                            onClick={ () => getCorrentItems(link) }>{ link }</div>
                                    )
                                })
                            }

                            {/* <span style={{ margin: '0 20px' }}>
                                [{ from } - { to }]
                            </span> */}

                            {/* <span>
                                <select value={ jobsPerPage } onChange={ _setJobsPerPage }>
                                    <option value='3'>3</option>
                                    <option value='5'>5</option>
                                    <option value='10'>10</option>
                                </select> 
                            </span> */}
                        </div>   {/*  End pagination div */}


                    {/*  End Jobs list div */}
                    </div>
                </>
            }

            {/* data !== null && data.length === 0 ?    */}
            {
                isLoading === false && 
                itemsNb === 0 && 
                data !== null && 
                data.length === 0 &&
                <div className='empty-result' id='emptyResult'>
                    <div className='small-white-ball'>
                    </div>
                    <div className='empty-search-message'>
                        {/* There are no listings matching your search. */}
                        There are no result.
                    </div>
                </div> 
            }
            </div>
        </div>

        <br/><br/>
        <Footer />


    </div>);
}






/*
import { useState } from 'react';
import './Search.css';

const Search = ({ placeholder, onChange }) => {
    //console.log("only search component has re-rendered");
    
    const [searchedText, setSearchText] = useState('');

    const removeSearchText = () => {
        setSearchText('');
        onChange('');
    }

    const searchText = (e) => {
        setSearchText(e.target.value);
        onChange(e.target.value);
    }

    return(
        <div className='search-container'>
            <i id="search-icon" className="fa fa-search" aria-hidden="true"></i>
            <input type='text'
                   className= 'search-input'
                   placeholder={ placeholder }
                   value={ searchedText }
                   onChange={ (e) => searchText(e) }/>
            { searchedText === '' ?
               '' : 
               <i id="clear-icon" 
               className="fa fa-times-circle-o"
               style={{ cursor: 'pointer' }}
               onClick={ removeSearchText }
               aria-hidden="true"></i>
            }
        </div>
    );
    
    
    /*
    *********
    Old code:
    *********
    return(
        <>
            <input type='checkbox' 
                   checked = { checking } 
                   onChange = { change } />
                   {`${checking}`} <br/><br/>
        </>
    );
}

*/

export default Search;

